module.exports = __webpack_public_path__ + "static/media/ritvij.983da983.jpg";